<div class="container">
    <div class="loader">
        <span></span>
    </div>
</div>
